/**
 * Utility Staples Data Catalog
 * According to the core requirement: Utility ingredients (like oil, salt, pepper, butter, water, basic spices)
 * do NOT count towards the 3-main-ingredient limit.
 */

export const UTILITY_STAPLES = [
  'salt',
  'black pepper',
  'pepper',
  'sea salt',
  'kosher salt',
  'olive oil',
  'vegetable oil',
  'cooking oil',
  'oil',
  'butter',
  'ghee',
  'margarine',
  'water',
  'ice water',
  'hot water',
  'garlic powder',
  'onion powder',
  'paprika',
  'chili flakes',
  'red pepper flakes',
  'oregano',
  'dried oregano',
  'vinegar',
  'white vinegar',
  'apple cider vinegar',
  'soy sauce',
  'lemon juice',
  'lime juice',
  'flour',
  'baking powder'
];

/**
 * Checks if an ingredient name is a utility staple
 * @param {string} ingredientName
 * @returns {boolean}
 */
export function isUtilityStaple(ingredientName) {
  if (!ingredientName) return false;
  const normalized = ingredientName.toLowerCase().trim();
  return UTILITY_STAPLES.some(staple => 
    normalized === staple || 
    normalized.endsWith(' ' + staple) ||
    normalized.startsWith(staple + ' ')
  );
}
